import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionFilters, (actionItem, index) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent(actionItem.popConfirm ? 'a-popconfirm' : 'span'), _mergeProps({
      key: `${index}-${actionItem.label}`,
      title: actionItem.title
    }, { ref_for: true }, actionItem.popConfirm), {
      default: _withCtx(() => [
        _createVNode(_component_a_button, _mergeProps({
          type: "link",
          loading: _ctx.loadingMap.get(_ctx.getKey(actionItem, index))
        }, { ref_for: true }, actionItem, { size: "small" }), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(actionItem.label), 1)
          ]),
          _: 2
        }, 1040, ["loading"])
      ]),
      _: 2
    }, 1040, ["title"]))
  }), 128))
}